/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetClaims200Response } from '../models';
// @ts-ignore
import type { GetEntityWorklists200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { WorklistEntityType } from '../models';
/**
 * WorklistEntityApi - axios parameter creator
 * @export
 */
export const WorklistEntityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get paginated worklists for an entity
         * @summary Get paginated worklists for an entity
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorklists: async (entityType: WorklistEntityType, entityId: string, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getEntityWorklists', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityWorklists', 'entityId', entityId)
            const localVarPath = `/api/v1/worklist/{entityType}/{entityId}/worklists`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all worklist entities
         * @summary Get all worklist entities
         * @param {string} worklistId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorklistEntities: async (worklistId: string, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'worklistId' is not null or undefined
            assertParamExists('getWorklistEntities', 'worklistId', worklistId)
            const localVarPath = `/api/v1/worklist/{worklistId}/entity/claim`
                .replace(`{${"worklistId"}}`, encodeURIComponent(String(worklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorklistEntityApi - functional programming interface
 * @export
 */
export const WorklistEntityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorklistEntityApiAxiosParamCreator(configuration)
    return {
        /**
         * Get paginated worklists for an entity
         * @summary Get paginated worklists for an entity
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityWorklists(entityType: WorklistEntityType, entityId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEntityWorklists200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityWorklists(entityType, entityId, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistEntityApi.getEntityWorklists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all worklist entities
         * @summary Get all worklist entities
         * @param {string} worklistId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorklistEntities(worklistId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClaims200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorklistEntities(worklistId, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistEntityApi.getWorklistEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorklistEntityApi - factory interface
 * @export
 */
export const WorklistEntityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorklistEntityApiFp(configuration)
    return {
        /**
         * Get paginated worklists for an entity
         * @summary Get paginated worklists for an entity
         * @param {WorklistEntityApiGetEntityWorklistsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityWorklists(requestParameters: WorklistEntityApiGetEntityWorklistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEntityWorklists200Response> {
            return localVarFp.getEntityWorklists(requestParameters.entityType, requestParameters.entityId, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all worklist entities
         * @summary Get all worklist entities
         * @param {WorklistEntityApiGetWorklistEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorklistEntities(requestParameters: WorklistEntityApiGetWorklistEntitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClaims200Response> {
            return localVarFp.getWorklistEntities(requestParameters.worklistId, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorklistEntityApi - interface
 * @export
 * @interface WorklistEntityApi
 */
export interface WorklistEntityApiInterface {
    /**
     * Get paginated worklists for an entity
     * @summary Get paginated worklists for an entity
     * @param {WorklistEntityApiGetEntityWorklistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistEntityApiInterface
     */
    getEntityWorklists(requestParameters: WorklistEntityApiGetEntityWorklistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEntityWorklists200Response>;

    /**
     * Get all worklist entities
     * @summary Get all worklist entities
     * @param {WorklistEntityApiGetWorklistEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistEntityApiInterface
     */
    getWorklistEntities(requestParameters: WorklistEntityApiGetWorklistEntitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClaims200Response>;

}

/**
 * Request parameters for getEntityWorklists operation in WorklistEntityApi.
 * @export
 * @interface WorklistEntityApiGetEntityWorklistsRequest
 */
export interface WorklistEntityApiGetEntityWorklistsRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistEntityApiGetEntityWorklists
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof WorklistEntityApiGetEntityWorklists
     */
    readonly entityId: string

    /**
     * 
     * @type {number}
     * @memberof WorklistEntityApiGetEntityWorklists
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof WorklistEntityApiGetEntityWorklists
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getWorklistEntities operation in WorklistEntityApi.
 * @export
 * @interface WorklistEntityApiGetWorklistEntitiesRequest
 */
export interface WorklistEntityApiGetWorklistEntitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorklistEntityApiGetWorklistEntities
     */
    readonly worklistId: string

    /**
     * 
     * @type {number}
     * @memberof WorklistEntityApiGetWorklistEntities
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof WorklistEntityApiGetWorklistEntities
     */
    readonly pgSize?: number
}

/**
 * WorklistEntityApi - object-oriented interface
 * @export
 * @class WorklistEntityApi
 * @extends {BaseAPI}
 */
export class WorklistEntityApi extends BaseAPI implements WorklistEntityApiInterface {
    /**
     * Get paginated worklists for an entity
     * @summary Get paginated worklists for an entity
     * @param {WorklistEntityApiGetEntityWorklistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistEntityApi
     */
    public getEntityWorklists(requestParameters: WorklistEntityApiGetEntityWorklistsRequest, options?: RawAxiosRequestConfig) {
        return WorklistEntityApiFp(this.configuration).getEntityWorklists(requestParameters.entityType, requestParameters.entityId, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all worklist entities
     * @summary Get all worklist entities
     * @param {WorklistEntityApiGetWorklistEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistEntityApi
     */
    public getWorklistEntities(requestParameters: WorklistEntityApiGetWorklistEntitiesRequest, options?: RawAxiosRequestConfig) {
        return WorklistEntityApiFp(this.configuration).getWorklistEntities(requestParameters.worklistId, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }
}

